import { Button, Col, DatePicker, Row, Select, Table, Tooltip } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  IconBanner,
  IconEdit,
  IconInfo,
  IconRecipe,
  IconStar,
  IconTextLink,
  IconTicket,
} from '../../assets/index';
import BreadCrumbComponent from '../../components/breadcrumb/BreadCrumbComponent';
import useDashBoard from '../../hooks/useDashBoard';
import { routePage, routes } from '../../utils/constants/constant';
import { formatMoney, isEmpty } from '../../utils/helpers/helpers';
import { actionGeneralInfo, actionGetListBank } from '../system/actions';
import BoxItem from './components/BoxItem';
import './Dashboard.scss';

const breadCrumbs = [
  {
    name: 'Trang chủ',
    isLink: false,
  },
  {
    name: 'Tổng quan',
    isLink: false,
  },
];
const listBoxItem = [
  {
    title: 'Banner',
    des: 'Tạo banner với hình ảnh đẹp trên trang của bạn',
    bg_color: '#48BB78',
    icon: <IconBanner />,
    link: routes.DASHBOARD_BANNER,
  },
  {
    title: 'Text Links',
    des: 'Đặt deep link vào nội dung của bạn',
    bg_color: '#ED8936',
    icon: <IconTextLink />,
    link: routes.DASHBOARD_TEXT_LINK,
  },
  {
    title: 'Mã Ưu Đãi',
    des: 'Tăng hoa hồng cho bạn và khuyến khích người dùng đặt dịch vụ',
    bg_color: '#7A64D2',
    icon: <IconTicket />,
    link: routes.DASHBOARD_PROMOTION,
  },
  {
    title: 'Co-branding',
    des: 'Thiết lập Trang Co-branded Landing Page của bạn',
    bg_color: '#9F5AB0',
    icon: <IconStar />,
    link: routes.DASHBOARD_CO_BRANDING,
  },
];

const { RangePicker } = DatePicker;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';

const Dashboard = (props) => {
  const columns = [
    {
      title: 'CID',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
    },
    {
      title: 'Chiến dịch',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
    },
    {
      title: 'Loại Quảng cáo',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
    },
    {
      title: 'Lượt xem',
      dataIndex: 'numVisitors',
      key: 'numVisitors',
      align: 'center',
    },
    {
      title: 'Tỉ lệ chuyển đổi đơn hàng',
      key: 'conversionRate',
      render: (tags, record) => <>{record.conversionRate}%</>,
      align: 'center',
    },
    {
      title: 'Đơn hàng đã đặt',
      key: 'numBookings',
      dataIndex: 'numBookings',
      align: 'center',
    },
    {
      title: 'Tổng doanh số',
      key: 'totalAmount',
      dataIndex: 'totalAmount',
      render: (totalAmount) => <>{`${formatMoney(totalAmount)} VNĐ`}</>,
      align: 'center',
    },
    // {
    //   title: "EPC",
    //   key: "totalCommission",
    //   dataIndex: "totalCommission",
    //   render: (totalCommission) => <>{`${formatMoney(totalCommission)} VNĐ`}</>,
    // },
    {
      title: '',
      key: 'action',
      render: (text, record) => {
        return (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (record.type === 'link') {
                props.history.push(
                  `${routes.DASHBOARD_TEXT_LINK}?aff_cid=${record.id}`
                );
              } else if (record.type === 'banner') {
                props.history.push(
                  `${routes.DASHBOARD_BANNER}?aff_cid=${record.id}`
                );
              }
            }}
          >
            <IconEdit />
          </div>
        );
      },
    },
  ];

  const {
    filterType,
    filterDate,
    listCampaign,
    userAffiliationInfo,
    onChange,
    onChangeDate,
    getInfoGeneralInfo,
  } = useDashBoard({
    ...props,
  });
  const profile = props?.profile || {};
  return (
    <div className='container-home'>
      <BreadCrumbComponent breadCrumbs={breadCrumbs} />
      <div className='title-container-home'>Tổng quan</div>{' '}
      {profile?.approvalStatus !== 'APPROVED' && (
        <div className='warning-text'>
          *Tài khoản của quý khách chưa được phê duyệt để tham gia chương trình
          đối tác của Mytour.
        </div>
      )}
      <div
        style={{
          pointerEvents: profile?.approvalStatus !== 'APPROVED' && 'none',
        }}
      >
        <div className='list-box'>
          {listBoxItem.map((el, idx) => (
            <BoxItem item={el} key={idx.toString()} />
          ))}
        </div>
        <div className='box-content-dashboard'>
          <div className='item-box-content-dashboard'>
            <div className='title-item-box-content-dashboard'>
              <span className='title-text'>Thu nhập</span>
              <Button
                type='text'
                className='btn-view-more'
                onClick={() => props.history.push(`${routes.INCOME_DETAIL}`)}
              >
                Xem chi tiết
              </Button>
            </div>
            <Row>
              <Col span={11} className='info-title'>
                <span className='text-info-title'>Số dư hiện tại</span>
                <Tooltip placement='top' title='Hoa hồng chưa thanh toán'>
                  <span className='tooltip'>
                    <IconInfo />
                  </span>
                </Tooltip>
              </Col>
              <Col span={13} className='info-title'>
                <span className='text-info-title'>
                  Lượt thanh toán gần nhất
                </span>
                <Tooltip
                  placement='top'
                  title='Bạn cần đạt tối thiểu 50.000đ hoa hồng để được thanh toán vào tài khoản ngân hàng'
                >
                  <div className='tooltip'>
                    <IconInfo />
                  </div>
                </Tooltip>
              </Col>
            </Row>
            <Row className='row-between'>
              <Col span={11}>
                <span className='value-info-title'>
                  {!isEmpty(userAffiliationInfo?.currentCommission)
                    ? formatMoney(userAffiliationInfo?.currentCommission)
                    : '0'}
                </span>
              </Col>
              <Col span={13}>
                <span className='value-info-title'>
                  {!isEmpty(userAffiliationInfo?.lastCommission)
                    ? formatMoney(userAffiliationInfo?.lastCommission)
                    : '-'}
                </span>
              </Col>
            </Row>
            <Row>
              <Col span={11} className='info-title'>
                <span className='text-info-title'>VNĐ</span>
              </Col>
              <Col span={13} className='info-title'>
                <span className='text-info-title'>VNĐ</span>
              </Col>
            </Row>
          </div>
          <div className='item-box-content-dashboard'>
            <div className='title-item-box-content-dashboard'>
              <span className='title-text'>Cấp bậc đối tác</span>
              <Button
                type='text'
                className='btn-view-more'
                onClick={() =>
                  props.history.push(
                    `${routePage.HELP.FAQS_HELP}?commission=true`
                  )
                }
              >
                Xem chi tiết
              </Button>
            </div>
            <Row>
              <Col span={11} className='info-title'>
                <span className='text-info-title'>Doanh số</span>
                <Tooltip
                  placement='top'
                  title='Doanh số bạn đạt được để hưởng mức hoa hồng tương ứng'
                >
                  <div className='tooltip'>
                    <IconInfo />
                  </div>
                </Tooltip>
              </Col>
              <Col span={13} className='info-title'>
                <span className='text-info-title'>Cấp bậc của bạn:</span>
                <div className='number-level'>
                  {userAffiliationInfo?.currentLevel || 0}
                </div>
              </Col>
            </Row>
            <Row style={{ paddingTop: '11px' }}>
              <Col span={11} className='bonus-price'>
                <div className='bonus-price-per-mouth'>
                  <span className='value-info-title'>
                    {`${formatMoney(userAffiliationInfo?.currentGMV || 0)}`}
                  </span>
                </div>
                <span className='text-info-title'>VNĐ</span>
              </Col>
              <Col span={13} className='bonus-price'>
                <span className='bonus-value'>Hoa hồng cộng thêm:</span>
                <div className='wrap-bonus'>
                  <div>
                    <span>- Khách sạn:</span>
                    <span style={{ fontWeight: 600 }}>{` ${
                      getInfoGeneralInfo()?.discount?.percent
                    }%`}</span>
                  </div>
                  <div>
                    <span>- Vé máy bay:</span>
                    <span style={{ fontWeight: 600 }}>
                      {` ${formatMoney(
                        getInfoGeneralInfo()?.discountFlight?.fixedAmount
                      )}VNĐ`}
                    </span>
                  </div>
                  <div>
                    <span>- Hàng tiêu dùng:</span>
                    <span style={{ fontWeight: 600 }}>
                      {` ${getInfoGeneralInfo()?.discountGrocery?.percent}%`}
                    </span>
                  </div>
                </div>

                <span className='des-bonus'>{`Mức doanh thu mục tiêu của cấp tiếp theo`}</span>
                <span style={{ fontWeight: 600 }}>{`${formatMoney(
                  getInfoGeneralInfo().gmvUp || 0
                )}đ`}</span>
              </Col>
            </Row>
          </div>
        </div>
        <div className='list-qc-content'>
          <div className='title-list-qc-content'>
            Danh sách quảng cáo của tôi
          </div>
          <div className='sort-filter-content'>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {/* <span style={{}}>Thời gian:</span> */}
              <RangePicker
                onChange={onChangeDate}
                format={dateFormat}
                value={filterDate}
                allowClear={false}
              />
            </div>

            <div className='filter'>
              <span style={{ paddingRight: '8px' }}>Loại quảng cáo:</span>
              <Select
                className='select'
                value={filterType}
                showSearch
                style={{ width: 150 }}
                placeholder='Chọn loại'
                optionFilterProp='all'
                onChange={onChange}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                <Option value='all'>Tất cả</Option>
                <Option value='link'>Text Links</Option>
                <Option value='banner'>Banner</Option>
              </Select>
            </div>
          </div>
          <div className='list-qc'>
            {isEmpty(listCampaign) ? (
              <div className='empty-qc'>
                <IconRecipe />
                <span style={{ paddingTop: 10 }}>
                  Chưa có danh sách quảng cáo
                </span>
              </div>
            ) : (
              <Table columns={columns} dataSource={listCampaign} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
    generalInfo: state.systemReducer.generalInfo,
  }),
  { actionGeneralInfo, actionGetListBank }
)(withRouter(Dashboard));
